export const geoApiOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "72a7195febmshb5d8c31e4bd0b4ap14dff3jsn3ecd6d88d471",
    "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com",
  },
};
export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";
export const WEATHER_API_KEY = "1ec9d9d387edcec73987e004883f93ad"; 
